/**
 * @file Created on Thu Jul 12 2018
 * @author PKl
 */
import Input from './Input';
export { InputValidated } from './Input';
export default Input;